export const ERROR = 'ERROR'
export const CLEAR = 'CLEAR'
export const SUCCESS = 'SUCCESS'
export const DEFAULT = 'DEFAULT'